import React, { useEffect, useMemo, useState } from "react";
import { withUser } from "@coverme/identity";
import { connect } from "react-redux";
import * as casesActions from "../actions/casesActions";
import { MyCasesFilters } from "../components/MyCasesFilters/MyCasesFilters";
import { MyCasesTable } from "../components/MyCasesTable/MyCasesTable";
import "../styles/dashboard.scss";
import { LoadingBar } from "../components/LoadingComponents/LoadingBar";
import { useFilters } from "../hooks/useFilters";
import { postAndDownloadFile } from "../services/fileDownloader";
import * as interviewActions from "../actions/interviewActions";
import * as lookupActions from "../actions/lookupActions";
import { getLookups } from "../actions/lookupActions";

export const MyCasesComponent = ({
    cases,
    caseMetadata,
    getCases,
    getPrograms,
    getCaseMetadata,
    updateCasesFilter,
    user,
    history,
    customerId,
    customerPrograms,
    customerFeatures,
    setSimplePersonDemographics,
    jurisdiction,
    getLookups,
    lookups,
}) => {
    const isLoading =
        cases.isInitialized === false ||
        caseMetadata.isInitialized === false ||
        caseMetadata.isLoading === true ||
        customerId === undefined;
    const [isProgramForm, SetIsProgramForm] = useState(false);

    useEffect(() => {
        if (customerId == undefined || customerId == null) {
            return;
        }
        getCaseMetadata(customerId);
        getPrograms(customerId);
        getLookups(customerId, jurisdiction);
    }, [customerId]);

    const { filters, setFilters, onFetchData } = useFilters(
        { includeDependentCustomers: true, includeDependentUsers: true },
        customerId,
        getCases,
        500,
        20
    );

    const formattedCases = useMemo(() => {
        if (cases.data != null && cases.data != undefined && cases.data.data.length > 0) {
            if (
                lookups?.automatedTags !== undefined &&
                lookups?.automatedTags !== null &&
                lookups?.manualTags !== undefined &&
                lookups?.manualTags !== null
            ) {
                let allTags = [...lookups.automatedTags, ...lookups.manualTags];
                cases.data.data.forEach(item => {
                    item.tagName = "";
                    let tagOption = allTags.filter(x => x.id === item.tag);
                    if (tagOption?.length > 0) {
                        item.tag = tagOption[0].tagName;
                    }
                });
                return cases.data;
            }
        }
        return cases.data;
    }, [cases.data, lookups.data]);

    const programs = useMemo(() => {
        if (caseMetadata?.data?.programs !== null && caseMetadata?.data?.programs?.length > 0) {
            return [
                ...caseMetadata.data.programs,
                { label: "All Financial Assistance Programs", value: "00000000-0000-0000-0000-000000000000" },
                { label: "All HPE Programs", value: "00000000-0000-0000-0000-000000000000" },
            ];
        }
    }, [caseMetadata.data.programs]);

    const exportEncounters = formData => {
        postAndDownloadFile(
            `/api/customer/${customerId}/encounters/search/export`,
            formData || {},
            {},
            false,
            "encounters.csv"
        );
    };
    function setIsProgramForm(isProgram) {
        SetIsProgramForm(isProgram);
    }
    return (
        <div className="cases">
            <LoadingBar isLoading={isLoading}>
                <MyCasesFilters
                    history={history}
                    cases={cases}
                    users={caseMetadata.data.users}
                    programs={programs}
                    customerPrograms={customerPrograms}
                    customers={caseMetadata.data.facilities}
                    submitFilter={setFilters}
                    exportEncounters={exportEncounters}
                    setIsProgramForm={setIsProgramForm}
                    showStartNewCase={true}
                    customerId={customerId}
                    customerFeatures={customerFeatures}
                    setSimplePersonDemographics={setSimplePersonDemographics}
                    user={user}
                    lookups={lookups}
                />
                <MyCasesTable
                    pagedCases={formattedCases}
                    onFetchData={onFetchData}
                    isLoading={cases.isLoading}
                    isProgramForm={isProgramForm}
                    customerFeatures={customerFeatures}
                />
            </LoadingBar>
        </div>
    );
};

export const MyCasesComponentWithUser = withUser(MyCasesComponent);

export const MyCasesContainer = connect(
    state => ({
        cases: state.cases.searchResults,
        caseMetadata: state.cases.searchMetadata,
        customerId: state.customer?.data?.customer?.GlobalId,
        jurisdiction: state.customer.data.jurisdictions,
        customerPrograms: state.customerPrograms.data,
        customerFeatures: state.customer?.data?.features,
        lookups: state.interviewLookups.data || {},
    }),
    dispatch => ({
        getCases: (customerId, query, cancellationToken) =>
            dispatch(casesActions.getCases(customerId, query, cancellationToken)),
        getCaseMetadata: customerId => dispatch(casesActions.getCaseMetadata(customerId)),
        getPrograms: customerId => dispatch(casesActions.getPrograms(customerId)),
        updateCasesFilter: (filter, query) => dispatch(casesActions.updateCasesFilter(filter, query)),
        setSimplePersonDemographics: data => dispatch(interviewActions.setSimplePersonDemographics(data)),
        getLookups: (customerId, jurisdiction) => dispatch(lookupActions.getLookups(customerId, jurisdiction)),
        
    })
)(MyCasesComponentWithUser);
